export default "__VITE_ASSET__CxATLOKw__"